/* eslint-disable no-empty-pattern */
import React from 'react';
import { Box, createStyles } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import JavaLogo from '../../../assets/education/JavaLogo.png';
import UCMLogo from '../../../assets/education/UCMLogo.png';
import UMLogo from '../../../assets/education/UMLogo.jpg';
import EducationEntry from './Entry';

const useStyles = createStyles((theme) => ({
  generalBox: {
    marginBlock: theme.spacing.sm,
    padding: theme.spacing.sm,
  },
  detailsBox: {
    margin: theme.spacing.sm,
  },
}));

interface EducationProps {
}

export default function Education({}: EducationProps) {
  const { classes } = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'education.content' });

  return (
    <Box className={classes.generalBox}>
      <EducationEntry
        title={t('dam.title')}
        level={t('dam.level')}
        startDate={t('dam.startDate')}
        endDate={t('dam.endDate')}
        place={t('dam.place')}
        logo={JavaLogo}
        contents={t('dam.contents.paragraphs', {
          returnObjects: true,
          defaultValue: [],
        })}
      />
      <EducationEntry
        title={t('mfp.title')}
        level={t('mfp.level')}
        startDate={t('mfp.startDate')}
        endDate={t('mfp.endDate')}
        place={t('mfp.place')}
        logo={UCMLogo}
        extras={[
          { title: t('mfp.extras.tfm.title'), description: t('mfp.extras.tfm.description') },
        ]}
        contents={t('mfp.contents.paragraphs', {
          returnObjects: true,
          defaultValue: [],
        })}
      />
      <EducationEntry
        title={t('gei.title')}
        level={t('gei.level')}
        startDate={t('gei.startDate')}
        endDate={t('gei.endDate')}
        place={t('gei.place')}
        logo={UMLogo}
        extras={t('gei.extras.paragraphs', {
          returnObjects: true,
          defaultValue: [],
        })}
        contents={t('gei.contents.paragraphs', {
          returnObjects: true,
          defaultValue: [],
        })}
      />
      <EducationEntry
        title={t('matematicas.title')}
        level={t('matematicas.level')}
        startDate={t('matematicas.startDate')}
        endDate={t('matematicas.endDate')}
        place={t('matematicas.place')}
        logo={UMLogo}
        contents={t('matematicas.contents.paragraphs', {
          returnObjects: true,
          defaultValue: [],
        })}
      />
    </Box>
  );
}
